import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@src/components/ui/button/button';
import { ConfirmationDialog } from '../dialogs/confirmation-dialog';
import { useFormContext } from 'react-hook-form';
import toastr from 'toastr';
import { cn } from '@src/utils/ui';

export const ConfirmTaskButton = ({ channelId, orderId, confirmOrder, isCreatedInBookNow, className }) => {
    const { handleSubmit } = useFormContext() || {};
    const [loading, setLoading] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const handleClick = async e => {
        e.preventDefault();
        e.stopPropagation();
        try {
            setLoading(true);
            await confirmOrder(orderId);
            if (handleSubmit) await handleSubmit();
            setOpenConfirmModal(true);
            setLoading(false);
        } catch (err) {
            console.error('Confirm error:', err);
            toastr.error('Please try again later.', 'Oops! Something went wrong.');
        }
    };

    const handleConfirm = async e => {
        e.preventDefault();
        e.stopPropagation();
        location.href = `/chat?channelId=${channelId}`;
    };

    return (
        <>
            {isCreatedInBookNow ? (
                <Button
                    variant='contained'
                    onClick={handleClick}
                    className={cn(['tw-w-auto', className])}
                    loading={loading}
                >
                    CONFIRM
                </Button>
            ) : null}
            <ConfirmationDialog
                open={openConfirmModal}
                onClose={() => setOpenConfirmModal(false)}
                onAgree={handleConfirm}
                cancelLabel='CLOSE'
                agreeLabel='GO TO INBOX'
                content={{
                    body: `Task Booking Confirmed`,
                    description:
                        'Before your task, please contact your customer via chat to confirm any key details (like address, entry instructions, parking info, or special notes). Connecting early helps avoid surprises and sets you up for a successful task.'
                }}
            />
        </>
    );
};

ConfirmTaskButton.propTypes = {
    channelId: PropTypes.string.isRequired,
    confirmOrder: PropTypes.func.isRequired,
    orderId: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    isCreatedInBookNow: PropTypes.bool
};
